import { Room } from 'matrix-js-sdk';
import { matrixClient } from '../client';

const roomCache = new Map<string, Room>();

/**
 * 根据房间ID获取房间对象
 * @param roomId 房间ID
 * @returns 返回Room对象，如果不存在则返回null
 */
export async function getRoomById(roomId: string): Promise<Room | null> {
    if (!matrixClient.client) return null;

    // 先尝试从缓存中查找
    if (roomCache.has(roomId)) {
        return roomCache.get(roomId) || null;
    }

    // 如果缓存中没有，则从客户端获取
    const room = matrixClient.client.getRoom(roomId);
    if (room) {
        roomCache.set(roomId, room);
        return room;
    }

    return null;
}
